module.exports = __webpack_public_path__ + "img/p3_bg.75ee6f7c.jpg";